const LAST_LOGIN_KEY = 'lastLogin'
export const getLastLoginTime = () => {
  const lastLogin = localStorage.getItem(LAST_LOGIN_KEY)
  return lastLogin ? new Date(lastLogin) : null
}
export const setLastLoginTime = () => {
  const timeStr = new Date().toISOString()
  localStorage.setItem(LAST_LOGIN_KEY, timeStr)
}
export const removeLastLoginTime = () => {
  localStorage.removeItem(LAST_LOGIN_KEY)
}
